import { Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-scroll-list-item',
    templateUrl: './scroll-list-item.component.html',
    styleUrls: ['./scroll-list-item.component.scss']
})
export class ScrollListItemComponent implements OnInit, OnChanges {
    @Input() index = -1;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() description: string;
    @Input() leftIcon: string;
    @Input() rightIcon: string;
    @Input() hasDelete = false;
    @Input() item: any;
    @Input() selected = false;
    @Input() highlighted = false;
    @Input() background: 'default' | 'green' | 'yellow' | 'red' | 'disabled' | 'disabled-done' | 'none' = 'default';
    @Input() text: 'default' | 'green-text' | 'yellow-text' | 'red-text' = 'default';
    @Output() select = new EventEmitter<any>();
    @Output() unselect = new EventEmitter<any>();
    @Output() rightIconClick = new EventEmitter<any>();
    @Output() deleteClick = new EventEmitter<any>();

    _classes = '';

    @HostListener('click', ['$event.target'])
    onBatchClick() {
        this.select.emit(this.item);
    }

    @HostBinding('class') get classes() {
        return this._classes;
    }

    constructor() {
    }

    ngOnInit(): void {
        this._classes = `${this.selected ? 'selected' : ''} ${this.background} ${this.text}`;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.background || changes.text || changes.selected) {
            this._classes = `${this.selected ? 'selected' : ''} ${this.background} ${this.text}`;
        }
    }

    onRightIconClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();

        this.rightIconClick.emit(this.item);
    }

    onDeleteIconClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();

        this.deleteClick.emit(this.item);
    }
}
